module.exports = __webpack_public_path__ + "img/LUTOP_Logo_System_Small.6bae75de.svg";